import { takeEvery, put, call, select, all } from "redux-saga/effects"

// Constantes
import {
  GET_PREPARED_CARDS_PLANNING,
  GET_OCCURRENCES_BY_DATES,
  GET_OCCURRENCES,
  GET_ACTUAL_OCCURRENCE,
} from "./constants"

import {
  DELETE_TEMPLATES_GOVERNANCE_BY_ID,
  DUPLICATE_TEMPLATES_GOVERNANCE,
  GET_TEMPLATES_STUDIO_BY_TYPE,
  GET_TEMPLATES_BY_ID_CONTROL,
  PATCH_LABEL_QUESTION_BY_ID,
  DELETE_TEMPLATES_BY_ID,
  POST_PUBLISH_TEMPLATES,
  PATCH_PUBLISHED_TEMPLATE,
  PATCH_TEMPLATES_BY_ID,
  GET_TEMPLATES_BY_TYPE,
  POST_DRAFT_TEMPLATES,
  GET_TEMPLATES_BY_ID,
  DUPLICATE_TEMPLATES,
  GET_TEMPLATES,
} from "../Templates/constants.js"

import {
  GET_GLOBAL_RESPONSE_INFORMATION_BY_TEMPLATE_ID,
  GET_GLOBAL_RESPONSE_INFORMATION_BY_RESPONSE_ID,
  GET_RESPONSES_BY_TEMPALTE_ID,
  GET_RESPONSE_BY_BUSINESS,
  DELETE_RESPONSES_BY_ID,
  PATCH_RESPONSES_BY_ID,
  GET_RESPONSE_BY_USER,
  GET_RESPONSE_BY_ID,
  ADD_RESPONSE_TO_SIMPLE_FORM,
  POST_RESPONSES,
  SAVE_RESPONSES,
  GET_RESPONSES,
  POST_FILES_FOR_RESPONSE,
  DELETE_FILE_FOR_RESPONSE,
} from "../Responses/constants.js"

import {
  GET_LIST_CHOICE_BY_ID,
  POST_LIST_CHOICE,
  GET_LIST_CHOICE,
} from "../ListChoice/constants.js"

// Actions
import {
  getPreparedCardsPlanningSuccessAction,
  getActualOccurrenceByDatesSuccess,
  setPlanningIsLoadingAction,
  getOccurrencesSuccess,
  getActualOccurrenceSuccess,
  getActualOccurrenceAction,
  getOccurrencesAction,
  setWaitingSavingAction,
} from "./actions"
import { setErrorMessage } from "Containers/Messages/actions"
import {
  getTemplateStudioByTypeSuccess,
  getTemplatesByControlIdSuccess,
  getTemplateStudioByTypeAction,
  getTemplateByTypeSuccess,
  getTemplateByTypeAction,
  getTemplatesByIdSuccess,
  getTemplatesSuccess,
  setLoaderDataAction,
  getTemplatesAction,
} from "../Templates/actions.js"
import {
  getGlobalResponseInformationByResponseIdSuccess,
  getGlobalResponseInformationByTemplateIdSuccess,
  getResponsesByTemplateIdSuccess,
  getResponsesByBusinessAction,
  getResponsesByBusinessSuccess,
  deleteResponseByIdSuccess,
  getResponsesByUserSuccess,
  patchResponseByIdSuccess,
  getResponseByIdSuccess,
  getResponsesSuccess,
  postResponseSuccess,
  postFileForResponseSuccessAction,
  saveResponseSuccess,
  getResponseByIdAction,
} from "../Responses/actions.js"
import {
  getListChoiceByIdSuccess,
  postListChoiceSuccess,
  getListChoicesSuccess,
  getListChoicesAction,
} from "../ListChoice/actions.js"

// Sagas
import {
  manageSuccessGenerator,
  responseTypeIsSuccess,
  manageErrorGenerator,
  responseTypeIsError,
  manageInfoGenerator,
  manageWarningGenerator,
} from "Containers/App/saga"
// Others sagas
import { deleteFileETL, postFileToS3 } from "ContainersForm/ETL/saga.js"
import { getAllPlanControl } from "ContainersForm/ControlPlans/saga.js"
import { getBusinessGroups } from "Containers/BusinessInformations/saga.js"
// Selectors
import {
  selectCurrentToken,
  selectLangageID,
  selectCurrentUser,
} from "Containers/Login/selectors.js"
import { selectBusiness, selectBusinessTag } from "Containers/BusinessInformations/selectors.js"
import { postNotificationAction } from "Containers/Notifications/actions.js"
import { selectFilesForResponse } from "ContainersForm/DisplayForm/selectors.js"

// Utils
import { getCors, postCors, patchCors, deleteCors } from "Utils/rulesCors"
import { loadSagaTranslation } from "Utils/sagaTranslation"
import { getLocaleSuffix } from "Utils/translationLoader"
import { config } from "Utils/config"
import request from "Utils/request"
import { removefileFromFilesResponses } from "./utils"
import { getListTemplateAndControlVisible } from "Containers/Governance/ControlPage/utils.js"
import { getControlReadyToPatch } from "ContainersForm/ControlPlans/utils.js"
import {
  formatDataCards,
  createOccurencesControls,
  relationResponseCards,
  businessClientCards,
} from "Components/Governance/utils.js"
import { generateTemplateNotification } from "Components/Notifications/utils"

//**********************************************************************************************
//************************************* SAGA TEMPLATE ******************************************
//**********************************************************************************************
//GET_TEMPLATES
function* getAllTemplatesSaga() {
  const token = yield select(selectCurrentToken)

  try {
    const response = yield call(
      request,
      `${config.FORM_BACK_URL}/templates`,
      getCors({ token: token })
    )

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getTemplatesSuccess(response.body))
      }
    }
  } catch (err) {
    console.error("[route] => /templates => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

//GET_TEMPLATES_BY_ID
function* getTemplateByIdSaga({ payload }) {
  const token = yield select(selectCurrentToken)

  try {
    const response = yield call(
      request,
      `${config.FORM_BACK_URL}/templates/${payload.templateId}`,
      getCors({ token: token })
    )

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getTemplatesByIdSuccess(response.body))
      }
    }
  } catch (err) {
    console.error("[route] => /templates/:templateId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* postPublishTemplateSaga({ payload }) {
  const { data, isCalledFrom, typeForm } = payload
  
  const currentUser = yield select(selectCurrentUser)
  const token = yield select(selectCurrentToken)

  const trad = yield call(loadSagaTranslation, currentUser?.LANGUAGE_ID)
  const localeSuffix = `_${getLocaleSuffix(currentUser?.LANGUAGE_ID)}`
  const notif = {
    to_principals: data?.parameters?.targetUsers?.usersIds?.map(id => {
      return `user:${id}`
    }),
    data: {
      event: `${trad?.ASSIGNATION_CONTROLE}`,
      elementInBold: `${data?.parameters?.process}`,
      byUser: `${currentUser.FIRSTNAME} ${currentUser.LASTNAME}`,
      infos: ``,
      email: {
        url: "https://pocketstudio.pocketresult.com/",
        event: `${currentUser.FIRSTNAME} ${currentUser.LASTNAME} ${trad?.ASSIGNATION_CONTROLE}`,
      },
    },
    ephemeral: false,
    channel_id: "control_assignment" + localeSuffix,
  }
  try {
    const response = yield call(
      request,
      `${config.FORM_BACK_URL}/publishTemplate`,
      postCors(data, { token: token })
    )

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
      yield put(setLoaderDataAction(false))
    } else if (responseTypeIsSuccess(response)) {
      if (isCalledFrom === "pocketStudio") {
      }
      yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(setLoaderDataAction(false))

      if (typeForm === "studio") {
        yield put(getTemplateStudioByTypeAction({ filterparam: "frommybusiness" }))
      } else {
        yield put(
          getTemplateByTypeAction({ filterparam: "frommybusiness", format: "controlsAndTemplates" })
        )
      }
      const infos_notif = generateTemplateNotification("control_plan_assignment", {
        notif,
        currentUser,
        trad,
      })
      yield put(postNotificationAction({ notif, infos_notif }))
    }
  } catch (err) {
    console.error("[route] => /publishTemplate => POST => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* postDraftTemplateSaga({ payload }) {
  
  const token = yield select(selectCurrentToken)
  const tokens = { token: token }
  const url = `${config.FORM_BACK_URL}/saveDraftTemplate`

  try {
    const response = yield call(request, url, postCors(payload.data, tokens))

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else if (responseTypeIsSuccess(response)) {
      if (payload.isCalledFrom === "pocketStudio") {
      }

      yield call(manageSuccessGenerator, { response, showMessageToUser: false })

      if (payload.typeForm === "studio") {
        yield put(getTemplateStudioByTypeAction({ filterparam: "frommybusiness" }))
      } else {
        yield put(
          getTemplateByTypeAction({ filterparam: "frommybusiness", format: "controlsAndTemplates" })
        )
      }
    }
  } catch (err) {
    console.error("[route] => /saveDraftTemplate => POST => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* patchPublishedTemplateSaga({ payload }) {
  const { data } = payload
  const token = yield select(selectCurrentToken)
  const businessTag = yield select(selectBusinessTag)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `publishTemplate`
  const requestURL = `${FORM_BACK_URL}/${endPath}`

  try {
    // We use same route to post publish template actullay
    const response = yield call(request, requestURL, postCors(data, specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else if (responseTypeIsSuccess(response)) {
      yield put(
        getTemplateByTypeAction({ filterparam: "frommybusiness", format: "controlsAndTemplates" })
      )
    }
    yield put(setLoaderDataAction(false))
  } catch (err) {
    console.error(`[route] => /${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
    yield put(setLoaderDataAction(false))
  }
}

// PATCH_TEMPLATES_BY_ID
function* patchTemplateSaga({ payload }) {
  
  const token = yield select(selectCurrentToken)

  try {
    const response = yield call(
      request,
      `${config.FORM_BACK_URL}/templates`,
      patchCors(payload.data, { token: token })
    )

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getTemplatesAction())
      }
    }
  } catch (err) {
    console.error("[route] => /templates => POST => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

// PATCH_LABEL_QUESTION_BY_ID
function* patchLabelQuestionSaga({ payload }) {
  
  const token = yield select(selectCurrentToken)

  try {
    const response = yield call(
      request,
      `${config.FORM_BACK_URL}/templates/${payload.templateId}/question/${payload.questionId}`,
      patchCors(payload.data, { token: token })
    )

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getTemplatesAction())
      }
    }
  } catch (err) {
    console.error(
      "[route] => /templates/:templateId/question/:questionId => POST => ERROR => ",
      err
    )
    yield put(setErrorMessage(err))
  }
}

// DELETE_TEMPLATES_BY_ID
function* deleteTemplateSaga({ payload }) {
  
  const token = yield select(selectCurrentToken)

  try {
    const response = yield call(
      request,
      `${config.FORM_BACK_URL}/deleteOrArchiveTemplate/${payload.templateId}`,
      deleteCors({ token: token })
    )

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getTemplateStudioByTypeAction({ filterparam: "frommybusiness" }))
      }
    }
  } catch (err) {
    console.error("[route] => /deleteOrArchiveTemplate/:templateId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

// DELETE_TEMPLATES_GOVERNANCE_BY_ID
function* deleteTemplateGovernanceSaga({ payload }) {
  
  const token = yield select(selectCurrentToken)

  try {
    const response = yield call(
      request,
      `${config.FORM_BACK_URL}/control/${payload.controlId}`,
      deleteCors({ token: token })
    )

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(
          getTemplateByTypeAction({ filterparam: "frommybusiness", format: "controlsAndTemplates" })
        )
      }
    }
  } catch (err) {
    console.error("[route] => /control/:controlId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

//GET_TEMPLATES_BY_TYPE
function* getTemplateByTypeSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const { FORM_BACK_URL } = config
  const myLanguageId = yield select(selectLangageID)
  const languageIdQuery = `languageId=${myLanguageId}`
  const requestURL = `${FORM_BACK_URL}/v2/controlsandtemplates?${languageIdQuery}`
  try {
    const response = yield call(request, requestURL, postCors(payload, { token: token }))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
      yield put(setLoaderDataAction(false))
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getTemplateByTypeSuccess(response.body))
        yield put(setLoaderDataAction(false))
        return response.body
      }
    }
  } catch (err) {
    console.error("[route] => /v2/controlsandtemplates => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

//GET_TEMPLATES_BY_ID_CONTROL
function* getTemplateByControlIdSaga({ payload }) {
  const token = yield select(selectCurrentToken)

  try {
    const response = yield call(
      request,
      `${config.FORM_BACK_URL}/v1/controlandtemplateByControlId/${payload.controlId}`,
      getCors({ token: token })
    )

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getTemplatesByControlIdSuccess(response.body))
      }
    }
  } catch (err) {
    console.error("[route] => /v1/controlandtemplateByControlId/:controlId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

//GET_TEMPLATES_STUDIO_BY_TYPE
function* getTemplateStudioByTypeSaga({ payload }) {
  const token = yield select(selectCurrentToken)

  try {
    const response = yield call(
      request,
      `${config.FORM_BACK_URL}/filteredtemplates/${payload.filterparam}`,
      getCors({ token: token })
    )
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
      yield put(setLoaderDataAction(false))
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getTemplateStudioByTypeSuccess(response.body))
        yield put(setLoaderDataAction(false))
      }
    }
  } catch (err) {
    console.error("[route] => /filteredtemplates/:filterparam => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

// duplicate template governance
function* duplicateTemplateGovernanceSaga({ payload }) {
  
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config

  var url = `${FORM_BACK_URL}/duplicateControl/${payload.controlId}`
  try {
    const response = yield call(request, url, postCors({}, specificHeaders))

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else if (responseTypeIsSuccess(response)) {
      yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(setLoaderDataAction(false))

      if (payload.typeForm === "studio") {
        yield put(getTemplateStudioByTypeAction({ filterparam: "frommybusiness" }))
      } else {
        yield put(
          getTemplateByTypeAction({ filterparam: "frommybusiness", format: "controlsAndTemplates" })
        )
      }
    }
  } catch (err) {
    console.error("[route] => /duplicateControl/:controlId => POST => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

// duplicate template formulaire studio
function* duplicateTemplateFormSaga({ payload }) {
  
  const token = yield select(selectCurrentToken)

  // delete key
  delete payload.data["_id"]
  delete payload.data["_etag"]
  delete payload.data["parameters"]["controlId"]
  delete payload.data["parameters"]["templateId"]

  try {
    const response = yield call(
      request,
      `${config.FORM_BACK_URL}/duplicateTemplateForm`,
      postCors(payload.data, { token: token })
    )

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else if (responseTypeIsSuccess(response)) {
      yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(setLoaderDataAction(false))

      if (payload.typeForm === "studio") {
        yield put(getTemplateStudioByTypeAction({ filterparam: "frommybusiness" }))
      } else {
        yield put(
          getTemplateByTypeAction({ filterparam: "frommybusiness", format: "controlsAndTemplates" })
        )
      }
    }
  } catch (err) {
    console.error("[route] => /duplicateTemplateForm => POST => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

//**********************************************************************************************
//************************************* SAGA REPONSE *******************************************
//**********************************************************************************************
//GET_RESPONSES
function* getAllResponsesSaga() {
  const token = yield select(selectCurrentToken)

  try {
    const response = yield call(
      request,
      `${config.FORM_BACK_URL}/responses`,
      getCors({ token: token })
    )

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getResponsesSuccess(response.body))
      }
    }
  } catch (err) {
    console.error("[route] => /responses => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

//GET_RESPONSE_BY_ID
export function* getResponsesByIdSaga({ payload }) {
  const { responseId } = payload
  const token = yield select(selectCurrentToken)

  if (!responseId) yield put(getResponseByIdSuccess({}))
  else
    try {
      const response = yield call(
        request,
        `${config.FORM_BACK_URL}/responses/${responseId}`,
        getCors({ token: token })
      )

      if (responseTypeIsError(response)) {
        yield call(manageErrorGenerator, { response, showMessageToUser: true })
      } else {
        if (responseTypeIsSuccess(response)) {
          yield call(manageSuccessGenerator, { response, showMessageToUser: false })
          yield put(getResponseByIdSuccess(response.body))
        }
      }
    } catch (err) {
      console.error("[route] => /responses/:responseId => ERROR => ", err)
      yield put(setErrorMessage(err))
    }
}

//GET_RESPONSES_BY_TEMPALTE_ID
function* getResponsesByTemplateIdSaga({ payload }) {
  const token = yield select(selectCurrentToken)

  try {
    const response = yield call(
      request,
      `${config.FORM_BACK_URL}/responsesByTemplate/${payload.templateId}`,
      getCors({ token: token })
    )

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getResponsesByTemplateIdSuccess(response.body))
      }
    }
  } catch (err) {
    console.error("[route] => /responsesByTemplate/:templateId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

//GET_GLOBAL_RESPONSE_INFORMATION_BY_TEMPLATE_ID
function* getGlobalResponsesInformationByTemplateIdSaga({ payload }) {
  const token = yield select(selectCurrentToken)

  try {
    const response = yield call(
      request,
      `${config.FORM_BACK_URL}/globalLatestResponseInformation/${payload.templateId}`,
      getCors({ token: token })
    )

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getGlobalResponseInformationByTemplateIdSuccess(response.body))
      }
    }
  } catch (err) {
    console.error("[route] => /globalLatestResponseInformation/:templateId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

//GET_GLOBAL_RESPONSE_INFORMATION_BY_RESPONSE_ID
function* getGlobalResponsesInformationByResponseIdSaga({ payload }) {
  const token = yield select(selectCurrentToken)

  try {
    const response = yield call(
      request,
      `${config.FORM_BACK_URL}/globalResponseInformation/${payload.responseId}`,
      getCors({ token: token })
    )

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getGlobalResponseInformationByResponseIdSuccess(response.body))
      }
    }
  } catch (err) {
    console.error("[route] => /globalResponseInformation/:responseId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

// POST_RESPONSES
function* postReponseSaga({ payload }) {
  const { newResponse, action, notification, infos_notif, control } = payload
  const token = yield select(selectCurrentToken)

  try {
    const response = yield call(
      request,
      `${config.FORM_BACK_URL}/governanceResponse`,
      postCors({ newResponse, action }, { token })
    )
    console.log("payload", payload)
    console.log("response", response)

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
      yield put(setLoaderDataAction(false))
      yield put(setWaitingSavingAction(false))
    } else if (response?.type === "warning") {
      yield call(manageWarningGenerator, { response, showMessageToUser: true })
      yield put(setLoaderDataAction(false))
      yield put(setWaitingSavingAction(false))
      yield put(getResponseByIdAction({ responseId: response?.body?.newResponseId }))
      yield put(
        getActualOccurrenceAction({
          controlId: control?._id?.$oid,
          occurrenceId: newResponse?.idOccurence,
        })
      )
    } else {
      yield call(manageSuccessGenerator, { response, showMessageToUser: true })
      yield put(postResponseSuccess(response.body))
      yield put(setLoaderDataAction(false))
      yield put(getResponseByIdAction({ responseId: response?.body?.newResponseId }))
      yield put(setWaitingSavingAction(false))
      yield put(
        getActualOccurrenceAction({
          controlId: control?._id?.$oid,
          occurrenceId: newResponse?.idOccurence,
        })
      )
      yield put(getOccurrencesAction())
      yield call(getPreparedCardsPlanning, {})

      if (notification) {
        const notif = {
          ...notification,
          data: {
            ...notification?.data,
            redirect_state: { responseId: response?.body?.newResponseId },
          },
        }

        yield put(postNotificationAction({ notif, infos_notif }))
      }
    }
  } catch (err) {
    console.error(`[route] => /governanceResponse => ERROR => `, err)
    yield put(setErrorMessage(err))
    yield put(setLoaderDataAction(false))
    yield put(setWaitingSavingAction(false))
  }
}

function* addCommonFormResponseSaga({ payload }) {
  const { newResponse, action } = payload
  const token = yield select(selectCurrentToken)
  

  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `/responses`
  const requestURL = `${FORM_BACK_URL}${endPath}`

  const body = { newResponse, action }

  try {
    const response = yield call(request, requestURL, postCors(body, specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
      yield put(setLoaderDataAction(false))
    } else {
      // if (notification) yield put(postNotificationAction(notification))
      yield call(manageSuccessGenerator, { response, showMessageToUser: true })
      yield put(postResponseSuccess(response.body))
      yield put(getResponsesByBusinessAction())
      yield put(getResponseByIdAction({ responseId: response?.body?.newResponseId }))
      yield put(setLoaderDataAction(false))
    }
  } catch (err) {
    console.error(`[route] => ${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
    yield put(setLoaderDataAction(false))
  }
}

function* patchReponseSaga({ payload }) {
  
  const token = yield select(selectCurrentToken)

  try {
    const response = yield call(
      request,
      `${config.FORM_BACK_URL}/responses/${payload.responseId}`,
      patchCors(payload, { token })
    )

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
      yield put(setWaitingSavingAction(false))
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
        yield put(setWaitingSavingAction(false))
      }
    }
  } catch (err) {
    console.error("[route] => /responsesByTemplate/:templateId => ERROR => ", err)
    yield put(setErrorMessage(err))
    yield put(setWaitingSavingAction(false))
  }
}
// SAVE_RESPONSES
function* saveReponseSaga({ payload }) {
  const { data, notif, infos_notif, action } = payload
  
  const token = yield select(selectCurrentToken)

  try {
    const response = yield call(
      request,
      `${config.FORM_BACK_URL}/saveResponse`,
      postCors(data, { token: token })
    )

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
      yield put(setLoaderDataAction(false))
    } else {
      if (responseTypeIsSuccess(response)) {
        if (notif) {
          const notifWithResponseId = {
            ...notif,
            data: {
              ...notif.data,
              redirect_state: { responseId: response?.body?.newResponseId },
            },
          }

          yield put(postNotificationAction({ notif: notifWithResponseId, infos_notif }))
        }
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
        yield put(saveResponseSuccess(response.body))
        yield put(getResponseByIdAction({ responseId: response?.body?.newResponseId }))
        yield put(getResponsesByBusinessAction())
        yield put(setLoaderDataAction(false))
        yield call(getPreparedCardsPlanning, {})
      }
    }
  } catch (err) {
    console.error("[route] => /saveResponse => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

// DELETE_RESPONSES_BY_ID
function* deleteReponseSaga({ payload }) {
  
  const token = yield select(selectCurrentToken)

  try {
    const response = yield call(
      request,
      `${config.FORM_BACK_URL}/responses/${payload.templateId}`,
      deleteCors({ token: token })
    )

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(deleteResponseByIdSuccess(response.body))
      }
    }
  } catch (err) {
    console.error("[route] => /responsesByTemplate/:templateId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

// GET_RESPONSE_BY_USER
function* getResponseByUserSaga() {
  
  const token = yield select(selectCurrentToken)

  try {
    const response = yield call(
      request,
      `${config.FORM_BACK_URL}/responsesByUser`,
      getCors({ token: token })
    )

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getResponsesByUserSuccess(response.body))
      }
    }
  } catch (err) {
    console.error("[route] => /responsesByUser => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

// GET_RESPONSE_BY_BUSINESS
function* getResponseByBusinessSaga() {
  
  const token = yield select(selectCurrentToken)

  try {
    const response = yield call(
      request,
      `${config.FORM_BACK_URL}/responsesByBusiness`,
      getCors({ token: token })
    )

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getResponsesByBusinessSuccess(response.body))
        return response.body
      }
    }
  } catch (err) {
    console.error("[route] => /responsesByBusiness => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

// POST FILE INTO ETL AND STORE
function* postFileForResponseSaga({ payload }) {
  const { newFile, documentTitle, documentRequestId } = payload
  const user = yield select(selectCurrentUser)
  const filesForResponse = yield select(selectFilesForResponse)
  try {
    const response = yield call(postFileToS3, newFile)
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      const newFilePosted = {
        title: documentTitle,
        fileName: response?.body?.name,
        creatorName: `${user?.FIRSTNAME} ${user?.LASTNAME}`,
        documentRequestId: documentRequestId,
      }
      const newFilesForResponse = [...filesForResponse, newFilePosted]
      yield put(postFileForResponseSuccessAction(newFilesForResponse))
    }
  } catch (err) {
    console.error(`[route] => ERROR POST FILE FOR RESPONSE => `, err)
    yield put(setErrorMessage(err))
  }
}

// DELETE FILE INTO ETL AND STORE
function* deleteFileForResponseSaga({ payload }) {
  const { fileName } = payload
  const filesForResponse = yield select(selectFilesForResponse)
  try {
    const response = yield call(deleteFileETL, fileName)
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      const newFilesForResponse = removefileFromFilesResponses(filesForResponse, fileName)
      yield put(postFileForResponseSuccessAction(newFilesForResponse))
    }
  } catch (err) {
    console.error(`[route] => ERROR POST FILE FOR RESPONSE => `, err)
    yield put(setErrorMessage(err))
  }
}

//**********************************************************************************************
//*********************************** SAGA LIST CHOICE *****************************************
//**********************************************************************************************
//GET_LIST_CHOICE
function* getAllListChoicesSaga() {
  const token = yield select(selectCurrentToken)

  try {
    const response = yield call(
      request,
      `${config.FORM_BACK_URL}/choicesLists`,
      getCors({ token: token })
    )

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getListChoicesSuccess(response.body))
      }
    }
  } catch (err) {
    console.error("[route] => /choicesLists => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

//GET_LIST_CHOICE_BY_ID
function* getListChoiceByIdSaga({ payload }) {
  const token = yield select(selectCurrentToken)

  try {
    const response = yield call(
      request,
      `${config.FORM_BACK_URL}/choicesLists/${payload.listId}`,
      getCors({ token: token })
    )

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getListChoiceByIdSuccess(response.body))
      }
    }
  } catch (err) {
    console.error("[route] => /choicesLists/:listId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

// POST_LIST_CHOICE
function* postListChoiceSaga({ payload }) {
  const { listToCreate } = payload
  
  const token = yield select(selectCurrentToken)

  try {
    const response = yield call(
      request,
      `${config.FORM_BACK_URL}/choicesLists`,
      postCors({ listToCreate }, { token: token })
    )

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getListChoicesAction())
        yield put(postListChoiceSuccess(response.body))
        yield put(setLoaderDataAction(false))
      }
    }
  } catch (err) {
    console.error("[route] => /choicesLists => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* getPreparedCardsPlanning({ payload }) {
  const myBusiness = yield select(selectBusiness)
  try {
    yield put(setPlanningIsLoadingAction(true))
    // We call all datas we need to get prepared cards for the planning
    const getTemplatePayload = { filterparam: "affectedToMe", format: "controlsAndTemplates" }
    const reponsesList = yield call(getResponseByBusinessSaga, {})
    const listControlPlans = yield call(getAllPlanControl, {})
    const businessGroups = yield call(getBusinessGroups, {})
    const fullControlList = yield call(getTemplateByTypeSaga, { payload: getTemplatePayload })

    // We prepared cards
    const fullControlListVisible = getListTemplateAndControlVisible(
      fullControlList,
      myBusiness?.tag
    )
    const hiddenCardsMitigant = fullControlListVisible.filter(
      fullControl => fullControl?.control?.type_control !== "mitigant"
    )
    const dataCard = formatDataCards(hiddenCardsMitigant, reponsesList)
    const dataCardOccurence = createOccurencesControls(dataCard)
    const dataCardResponse = relationResponseCards(dataCardOccurence, reponsesList, myBusiness?.tag)
    const preparedCardsPlanning = businessClientCards(
      dataCardResponse,
      listControlPlans,
      businessGroups
    )

    // We passed cards to our store
    if (Array.isArray(preparedCardsPlanning)) {
      yield put(getPreparedCardsPlanningSuccessAction(preparedCardsPlanning))
      yield put(setPlanningIsLoadingAction(false))
    }
  } catch (error) {
    console.log("[error] => getPreparedCardsPlanning", error)
  }
}

const logRequestDuration = (start, end) => {
  console.log(`request took ${parseInt(end - start)} ms.`)
}

function* getControlsOccurrences({ payload }) {
  
  const token = yield select(selectCurrentToken)

  yield put(setPlanningIsLoadingAction(true))

  try {
    const response = yield call(
      request,
      `${config.FORM_BACK_URL}/controlsOccurrences`,
      getCors({ token })
    )

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else if (responseTypeIsSuccess(response)) {
      yield call(manageSuccessGenerator, { response, showMessageToUser: false })

      if (Array.isArray(response.body)) {
        // const end = performance.now()
        // logRequestDuration(start, end)
        yield put(getOccurrencesSuccess(response.body))
        yield put(setPlanningIsLoadingAction(false))
      }
    }
  } catch (error) {
    console.log(`[error] => /controlsOccurrences`, error)
  }
}

function* getControlsOccurrencesByDates({ payload }) {
  
  const token = yield select(selectCurrentToken)

  yield put(setPlanningIsLoadingAction(true))

  const queryVariable = `?timestampStart=${payload?.timestampStart}&timestampEnd=${payload?.timestampEnd}`

  try {
    const response = yield call(
      request,
      `${config.FORM_BACK_URL}/controlsOccurrencesByDates${queryVariable}`,
      getCors({ token })
    )

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else if (responseTypeIsSuccess(response)) {
      yield call(manageSuccessGenerator, { response, showMessageToUser: false })

      if (Array.isArray(response.body)) {
        // const end = performance.now()
        // logRequestDuration(start, end)
        yield put(getOccurrencesSuccess(response.body))
        yield put(setPlanningIsLoadingAction(false))
      }
    }
  } catch (error) {
    console.log(`[error] => /controlsOccurrencesByDates`, error)
  }
}

function* getActualControlsOccurrence({ payload }) {
  
  const token = yield select(selectCurrentToken)
  const tokens = { token: token }

  const { controlId, occurrenceId } = payload
  let queryArr = [`controlId=${controlId}`]
  if (occurrenceId) queryArr.push(`occurrenceId=${occurrenceId}`)
  const endPath = `/occurrenceContent?${queryArr.join("&")}`
  const url = `${config.FORM_BACK_URL}${endPath}`

  try {
    const response = yield call(request, url, getCors(tokens))

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else if (responseTypeIsSuccess(response)) {
      yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(getActualOccurrenceSuccess(response.body))
    }
  } catch (error) {
    console.log(`[error] => ${endPath}`, error)
  }
}

function* formSaga() {
  // Templates
  yield takeEvery(DUPLICATE_TEMPLATES_GOVERNANCE, duplicateTemplateGovernanceSaga)
  yield takeEvery(DELETE_TEMPLATES_GOVERNANCE_BY_ID, deleteTemplateGovernanceSaga)
  yield takeEvery(GET_TEMPLATES_STUDIO_BY_TYPE, getTemplateStudioByTypeSaga)
  yield takeEvery(GET_TEMPLATES_BY_ID_CONTROL, getTemplateByControlIdSaga)
  yield takeEvery(PATCH_LABEL_QUESTION_BY_ID, patchLabelQuestionSaga)
  yield takeEvery(POST_PUBLISH_TEMPLATES, postPublishTemplateSaga)
  yield takeEvery(DUPLICATE_TEMPLATES, duplicateTemplateFormSaga)
  yield takeEvery(GET_TEMPLATES_BY_TYPE, getTemplateByTypeSaga)
  yield takeEvery(POST_DRAFT_TEMPLATES, postDraftTemplateSaga)
  yield takeEvery(PATCH_PUBLISHED_TEMPLATE, patchPublishedTemplateSaga)
  yield takeEvery(DELETE_TEMPLATES_BY_ID, deleteTemplateSaga)
  yield takeEvery(GET_TEMPLATES_BY_ID, getTemplateByIdSaga)
  yield takeEvery(PATCH_TEMPLATES_BY_ID, patchTemplateSaga)
  yield takeEvery(GET_TEMPLATES, getAllTemplatesSaga)
  // Responses
  yield takeEvery(
    GET_GLOBAL_RESPONSE_INFORMATION_BY_TEMPLATE_ID,
    getGlobalResponsesInformationByTemplateIdSaga
  )
  yield takeEvery(
    GET_GLOBAL_RESPONSE_INFORMATION_BY_RESPONSE_ID,
    getGlobalResponsesInformationByResponseIdSaga
  )
  yield takeEvery(GET_RESPONSES_BY_TEMPALTE_ID, getResponsesByTemplateIdSaga)
  yield takeEvery(GET_RESPONSE_BY_BUSINESS, getResponseByBusinessSaga)
  yield takeEvery(GET_RESPONSE_BY_USER, getResponseByUserSaga)
  yield takeEvery(DELETE_RESPONSES_BY_ID, deleteReponseSaga)
  yield takeEvery(GET_RESPONSE_BY_ID, getResponsesByIdSaga)
  yield takeEvery(PATCH_RESPONSES_BY_ID, patchReponseSaga)
  yield takeEvery(GET_RESPONSES, getAllResponsesSaga)
  yield takeEvery(POST_RESPONSES, postReponseSaga)
  yield takeEvery(ADD_RESPONSE_TO_SIMPLE_FORM, addCommonFormResponseSaga)
  yield takeEvery(SAVE_RESPONSES, saveReponseSaga)
  yield takeEvery(POST_FILES_FOR_RESPONSE, postFileForResponseSaga)
  yield takeEvery(DELETE_FILE_FOR_RESPONSE, deleteFileForResponseSaga)
  // List Choice
  yield takeEvery(GET_LIST_CHOICE_BY_ID, getListChoiceByIdSaga)
  yield takeEvery(GET_LIST_CHOICE, getAllListChoicesSaga)
  yield takeEvery(POST_LIST_CHOICE, postListChoiceSaga)

  yield takeEvery(GET_PREPARED_CARDS_PLANNING, getPreparedCardsPlanning)
  yield takeEvery(GET_OCCURRENCES, getControlsOccurrences)
  yield takeEvery(GET_ACTUAL_OCCURRENCE, getActualControlsOccurrence)
  yield takeEvery(GET_OCCURRENCES_BY_DATES, getControlsOccurrencesByDates)
}

export default formSaga
